import { all, call, takeEvery } from 'redux-saga/effects'
import { gaPageView } from '../analytics'

function* getPageView() {
  try {
    yield call(gaPageView, 100)
  } catch(error) {
    // console.log(error)
  }
}

function* watchGetPageView() {
  yield takeEvery('PAGE_VIEW', getPageView)
}

export const analyticsSaga = [
  watchGetPageView()
]

export default function* rootSaga() {
  yield all([
    ...analyticsSaga
  ])
}


// WEBPACK FOOTER //
// ./src/sagas/analytics.js